import * as ContactMeta from './ContactMeta.jsx';
import { ContainerTypeConfig as LineItemCellTypeConfig, MetaTokens as LineItemCellMetaTokens } from '../invoice/LineItemCell.jsx';
import * as LineItems from '../invoice/LineItems.jsx';
import * as MetaDate from '../common/MetaDate.jsx';
import * as MetaNotes from '../common/MetaNotes.jsx';
import * as MetaStaff from '../common/MetaStaff.jsx';
import * as MetaValidThrough from './MetaValidThrough.jsx';
import Name from '../utility/Name.jsx';
import * as TotalsDiscount from '../common/TotalsDiscount.jsx';
import * as TotalsGrandTotal from '../common/TotalsGrandTotal.jsx';
import * as TotalsShipping from '../common/TotalsShipping.jsx';
import * as TotalsTaxes from '../common/TotalsTaxes.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: 'offerSeparator',
            dataType: 'separator',
            display: 'Offer',
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(),
                Style: ContactMeta.TypeConfig.panel.style(),
                Description: ContactMeta.TypeConfig.panel.description(),
                Label: ContactMeta.TypeConfig.panel.label(),
                Value: ContactMeta.TypeConfig.panel.value()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Date,
            component: MetaDate.Component,
            config: {
                Block: MetaDate.TypeConfig.panel.block(),
                Style: MetaDate.TypeConfig.panel.style(),
                Description: MetaDate.TypeConfig.panel.description(),
                Label: MetaDate.TypeConfig.panel.label(),
                Value: MetaDate.TypeConfig.panel.value()
            },
            display: 'Offer Date',
            group,
            image: ''
        },
        {
            id: Name.Block.ValidThrough,
            component: MetaValidThrough.Component,
            config: {
                Block: MetaValidThrough.TypeConfig.panel.block(),
                Style: MetaValidThrough.TypeConfig.panel.style(),
                Description: MetaValidThrough.TypeConfig.panel.description(),
                Label: MetaValidThrough.TypeConfig.panel.label(),
                Value: MetaValidThrough.TypeConfig.panel.value()
            },
            display: 'Valid Through',
            group,
            image: ''
        },
        {
            id: Name.Block.Company.StaffName,
            component: MetaStaff.Component,
            config: {
                Block: MetaStaff.TypeConfig.panel.block(),
                Style: MetaStaff.TypeConfig.panel.style(),
                Description: MetaStaff.TypeConfig.panel.description(),
                Label: MetaStaff.TypeConfig.panel.label('Prepared By:'),
                Value: MetaStaff.TypeConfig.panel.value(),
                Visibility: MetaStaff.TypeConfig.panel.visibility()
            },
            display: 'User Name',
            group,
            image: ''
        },
        {
            id: Name.Block.Notes,
            component: MetaNotes.Component,
            config: {
                Block: MetaNotes.TypeConfig.panel.block(),
                Style: MetaNotes.TypeConfig.panel.style(),
                Description: MetaNotes.TypeConfig.panel.description(),
                Label: MetaNotes.TypeConfig.panel.label('Notes'),
                Value: MetaNotes.TypeConfig.panel.value(),
                Visibility: MetaNotes.TypeConfig.panel.visibility('Offer Notes')
            },
            display: 'Offer Notes',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCellTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        {
            id: Name.Block.Total.Discount,
            component: TotalsDiscount.Component,
            config: {
                Block: TotalsDiscount.TypeConfig.panel.block(),
                Style: TotalsDiscount.TypeConfig.panel.style(),
                Description: TotalsDiscount.TypeConfig.panel.description(),
                Label: TotalsDiscount.TypeConfig.panel.label(),
                Value: TotalsDiscount.TypeConfig.panel.value(data)
            },
            display: 'Discount',
            group,
            image: ''
        },
        {
            id: 'taxes',
            component: TotalsTaxes.Component,
            config: {
                Block: TotalsTaxes.TypeConfig.panel.block(),
                Style: TotalsTaxes.TypeConfig.panel.style(),
                Description: TotalsTaxes.TypeConfig.panel.description(),
                Label: TotalsTaxes.TypeConfig.panel.label(),
                Value: TotalsTaxes.TypeConfig.panel.value(data)
            },
            display: 'Taxes',
            group,
            image: ''
        },
        {
            id: 'shipping',
            component: TotalsShipping.Component,
            config: {
                Block: TotalsShipping.TypeConfig.panel.block(),
                Style: TotalsShipping.TypeConfig.panel.style(),
                Description: TotalsShipping.TypeConfig.panel.description(),
                Label: TotalsShipping.TypeConfig.panel.label(),
                Value: TotalsShipping.TypeConfig.panel.value(data)
            },
            display: 'Shipping',
            group,
            image: ''
        },
        {
            id: 'grandTotal',
            component: TotalsGrandTotal.Component,
            config: {
                Block: TotalsGrandTotal.TypeConfig.panel.block(),
                Style: TotalsGrandTotal.TypeConfig.panel.style(),
                Description: TotalsGrandTotal.TypeConfig.panel.description(),
                Label: TotalsGrandTotal.TypeConfig.panel.label('Total'),
                Value: TotalsGrandTotal.TypeConfig.panel.value(data)
            },
            display: 'Grand Total',
            group,
            image: ''
        }
    ]
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Company.StaffName:
                return MetaStaff.Tokens();
            case Name.Block.Date:
                return MetaDate.Tokens();
            case Name.Block.Inventory.Meta:
                return LineItemCellMetaTokens(data);
            case Name.Block.Total.Discount:
                return TotalsDiscount.Tokens(data);
            case Name.Block.Total.GrandTotal:
                return TotalsGrandTotal.Tokens(data);
            case Name.Block.Total.Shipping:
                return TotalsShipping.Tokens(data);
            case Name.Block.Total.Taxes:
                return TotalsTaxes.Tokens(data);
            case Name.Block.ValidThrough:
                return MetaValidThrough.Tokens();
        }
    }
};

export {
    Blocks,
    Tokens
}